import { defaultGetAction } from '../../utils';

import {
  GET_POST_TAGS
} from './constants';

export const loadPostTags = defaultGetAction(GET_POST_TAGS, 'post_tags/');



// WEBPACK FOOTER //
// ./src/redux/PostTags/actions.js